// Badge.tsx — Uppercase status/scope chip bound to design tokens.
import React from 'react';

export type BadgeTone = 'default' | 'info' | 'warning';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    tone?: BadgeTone;
}

export const Badge: React.FC<BadgeProps> = ({
    tone = 'default',
    style,
    children,
    ...rest
}) => {
    let color: string;
    if (tone === 'info') {
        color = 'var(--color-info)';
    } else if (tone === 'warning') {
        color = 'var(--color-warning)';
    } else {
        color = 'var(--color-text-secondary)';
    }

    const baseStyle: React.CSSProperties = {
        display: 'inline-block',
        background: 'var(--color-surface-overlay-strong)',
        color,
        borderRadius: 'var(--radius-sm)',
        padding: '0.125rem 0.5rem',
        fontFamily: 'var(--type-label-family)',
        fontSize: 'var(--type-label-size)',
        fontWeight: 'var(--type-label-weight)' as React.CSSProperties['fontWeight'],
        lineHeight: 'var(--type-label-line-height)',
        letterSpacing: 'var(--type-label-letter-spacing)',
        textTransform: 'uppercase',
        ...style,
    };

    return (
        <span style={baseStyle} {...rest}>
            {children}
        </span>
    );
};

export default Badge;
